module.exports = __webpack_public_path__ + "img/young-woman-with-smartphone.6ced61b9.png";